import { toast } from 'react-toastify'; // eslint-disable-next-line

export const copy = contnet => {
	var checkData = JSON.parse(localStorage.getItem('idiom'));
	navigator.clipboard.writeText(contnet);
	toast.success(checkData.MEM['MEM036'] ? checkData.MEM['MEM036'] : '');
	return 1;
};
